import React from 'react';
export function MatrixE2Section() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1391">
      <div className="flex flex-col md:flex-row" data-id="element-1392">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1393">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Matrix%20E2.png" alt="MATRIX E2" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1394" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1395">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1396">
            MATRIX E2
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1397">
            High Dynamic and High Precision 5-axis Modular Vertical Gantry
            Machining Center
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1398">
            <p className="leading-relaxed" data-id="element-1399">
              The development of this machining center was based on careful
              technical choices that combine thrust and robustness with dynamics
              and precision for perfect performance in hi-feed{' '}
              <strong data-id="element-1400">
                roughing, semi-finishing and finishing of medium-large
                workpieces in steel, lightweight alloys, and special composites.
              </strong>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm space-y-3" data-id="element-1401">
              <div data-id="element-1402">
                <strong className="text-navy block mb-1" data-id="element-1403">
                  Matrix E2 1100 K25
                </strong>
                <p data-id="element-1404">Travels (X,Y,Z): 98.43" x 98.43" x 43.31"</p>
              </div>
              <div data-id="element-1405">
                <strong className="text-navy block mb-1" data-id="element-1406">
                  Matrix E2 1100 K40
                </strong>
                <p data-id="element-1407">Travels (X,Y,Z): 157.5" x 98.43" x 43.31"</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1408">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Matrix%20E2" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1409">
              <span className="mr-2" data-id="element-1410">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/breton-matrix-e2" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1411">
              <span className="mr-2" data-id="element-1412">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}